import React from 'react';
import BriefView from './screens/BriefView';
import axios from "axios"

axios.defaults.headers.common['X-CSRF-Token'] = document.querySelectorAll('meta[name="csrf-token"]')[0]['content'];

export default props => (
  <BriefView {...props} />
);



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/index.js